export default __webpack_public_path__ + "static/media/27t.b2974a02.jpg";